import { render, staticRenderFns } from "./TemplateHelpModal.vue?vue&type=template&id=edacc2dc&scoped=true"
import script from "./TemplateHelpModal.vue?vue&type=script&lang=js"
export * from "./TemplateHelpModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edacc2dc",
  null
  
)

export default component.exports